import { ALL_PERMISSIONS } from "./permissions";
export var ALL_ROLES = [{
  id: 2,
  name: "UserAdmin",
  description: "Can manage users",
  permissions: [ALL_PERMISSIONS[0], ALL_PERMISSIONS[1]]
}, {
  id: 3,
  name: "OrderCreator",
  description: "Can create and view orders",
  permissions: [ALL_PERMISSIONS[2], ALL_PERMISSIONS[4]]
}, {
  id: 4,
  name: "OrderSubmitter",
  description: "Can create, submit and view orders",
  permissions: [ALL_PERMISSIONS[2], ALL_PERMISSIONS[3], ALL_PERMISSIONS[4]]
}, {
  id: 5,
  name: "OrderViewer",
  description: "Can only view orders",
  permissions: [ALL_PERMISSIONS[4]]
}];